<template>
  <el-container>
    <el-header class="m-t-2">
      <p class="main-heading">Congrats!</p>
      <p class="sub-heading">You are ready to start enjoying millions of podcasts on Luminary!</p>
    </el-header>
    <el-main class="m-t-2">
      <el-row>
        <el-col
          :md="{span:14,offset:5}"
          :sm="{span:18, offset:3}"
          :xs="{span:24}"
          class="main-content">
          <div class="main-heading">
            <p>Try Luminary Premium</p>
          </div>
          <!-- Features -->
          <el-row
            align="middle"
            justify="space-around">
            <el-col
              :md="{span:8}"
              :sm="{span:24}"
              class="t-c">
              <div class="circle"/>
              <p>Great exclusive and original content</p>
            </el-col>
            <el-col
              :md="{span:8}"
              :sm="{span:24}"
              class="t-c" >
              <div class="circle"/>
              <p>Support creators and let them make content</p>
            </el-col>
            <el-col
              :md="{span:8}"
              :sm="{span:24}"
              class="t-c" >
              <div class="circle"/>
              <p>No ads, great app, other cool things</p>
            </el-col>
          </el-row>
          <!-- Shows -->
          <div class="p-t-2">
            <p class="t-c">
              <strong>Some of the shows available on Luminary Premium</strong>
            </p>
            <el-row
              class="m-t-2"
              align="middle"
              justify="center">
              <el-col
                :md="{span:14,offset:5}"
                :xs="{span:24}">
                <el-row class="m-t">
                  <el-col :span="6">
                    <div class="square"/>
                  </el-col>
                  <el-col
                    :span="16"
                    :offset="2">
                    <p class="m-l">Crimetown, the award-winning true crime show about crime</p>
                  </el-col>
                </el-row>
                <el-row class="m-t">
                  <el-col :span="6">
                    <div class="square"/>
                  </el-col>
                  <el-col
                    :span="16"
                    :offset="2">
                    <p class="m-l">Atlanta Monster, the award-winning true crime show about crime</p>
                  </el-col>
                </el-row>
                <el-row class="m-t">
                  <el-col :span="6">
                    <div class="square"/>
                  </el-col>
                  <el-col
                    :span="16"
                    :offset="2">
                    <p class="m-l"> S-Town, the award-winning true crime show about crime</p>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <!-- Price -->
          <div v-loading="!plansLoaded"/>
          <div
            v-if="activePlan && pricing"
            class="t-c">
            <p class="main-heading">{{ activePlan.name }}</p>
            <p
              class="main-heading">
              {{ pricing[0].currency + ' ' + pricing[0].price }}
            </p>
            <p>Cancel Any time</p>
            <el-button
              type="primary"
              class="purchase-btn"
              @click="buyPremium">
              Get Luminary Premium
            </el-button>
          </div>
        </el-col>
      </el-row>
      <div class="t-c m-3">
        <router-link :to="'/listen'">Not right now, I'll use Luminary free</router-link>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Premium',
  data() {
    return {
      activePlan: null,
      activePlanCharges: null,
      pricing: null,
    };
  },
  computed: {
    plansLoaded() {
      if (this.$store.getters.plansLoaded) {
        this.setPricingPlans();
      }
      return this.$store.getters.plansLoaded;
    },
  },
  mounted() {
    window.eventBus.$emit('onboarding-step-change', -1);
  },
  methods: {
    setPricingPlans() {
      this.activePlan = this.$store.getters.activePlan;
      this.activePlanCharges = this.$store.getters.activePlanCharges;
      if (this.activePlan && this.activePlanCharges) {
        this.pricing = this.activePlanCharges.pricing;
      }
    },
    buyPremium() {
      this.$router.push('/premium-buy');
    },
  },
};
</script>

<style lang='scss' scoped>
  .main-heading {
    font-size: 20px;
    padding-bottom: 1rem;
    text-align: center;
  }
  .el-main {
    padding:10px;
  }
  .sub-heading {
    text-align: center;
  }
  .main-content {
    background-color: #E9EEF3;
    min-height: 500px;
    padding: 25px 10px;
    .circle {
      border-radius: 50%;
      background-color: #ffffff;
      margin: auto;
      height: 80px;
      width: 80px;
    }

    .m-auto {
      margin: auto;
    }

    .flex-column {
      flex-direction: column;
    }

    .square {
      background-color: #ffffff;
      height: 60px;
      min-width: 80px;
    }

    .purchase-btn {
      color: #ffffff;
      margin-top: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// app/src/pages/onboarding/PremiumInfo.vue